/* v3.0.28 - Shopify policy editor content can repeat the policy title as the
   first H2. Keep the semantic page H1 and suppress only a genuinely redundant
   content heading; all real subsection headings remain untouched. */
(function () {
  'use strict';

  function normalise(value) {
    return (value || '')
      .toLocaleLowerCase('en')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  var title = document.querySelector('.shopify-policy__title h1');
  var firstHeading = document.querySelector('.shopify-policy__body .rte > h2:first-child');
  if (!title || !firstHeading) return;

  var titleText = normalise(title.textContent);
  var headingText = normalise(firstHeading.textContent);
  var refundAlias = titleText === 'refund policy' && headingText === 'refund and returns policy';

  if (titleText === headingText || refundAlias) {
    firstHeading.hidden = true;
    firstHeading.setAttribute('aria-hidden', 'true');
    firstHeading.dataset.redundantPolicyHeading = 'true';
  }
})();
